
define('app/users/recover/recoverMain',[
	'domReady',
	'app/users/recover/recoverApp',
	'app/common/setup',
	'unknown/unknownSetup'
], function(domReady, RecoverApp, Setup, UnknownSetup){
	domReady(function () {
		Setup.initialize();
		RecoverApp.initialize();
		UnknownSetup.initialize();
    });
});